// src/utils/tokenUtils.js
import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (token) => {
  if (!token) return true; // Se não houver token, considerar como expirado

  const decodedToken = jwtDecode(token);
  const currentTime = Date.now() / 1000; // Tempo atual em segundos

  return decodedToken.exp < currentTime; // Verifica se o token está expirado
};
